<template>
  <div class="text-textColor overflow-hidden">
    <transition name="fade">
      <div
        v-if="showClaimWorkflow"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full overflow-hidden"
      >
        <div
          class="fixed overflow-y-auto max-h-screen center-h-v bg-white rounded-md shadow-2xl sm:w-3/5 w-full p-2"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">{{ getCurrentClaimWorkflow.Name }} Workflow</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="create_success"
              class="p-1 text-center text-white text-sm w-full bg-green-200"
            >
              {{ create_success }}
            </div>
          </transition>
          <transition name="fade">
            <div
              v-if="create_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ create_error }}
            </div>
          </transition>
          <div>
            <div class="grid lg:grid-cols-2 p-3 gap-5">
              <div class="text-sm">
                <label class="block pb-1"> Name</label>
                <input
                  v-model="getCurrentClaimWorkflow.Name"
                  type="text"
                  required
                  class="p-2 bg-gray-200 rounded-full w-full"
                  readonly
                />
              </div>
              <div class="text-sm">
                <label class="block pb-1">Any Can Approve</label>
                <div class="p-2 bg-gray-200 rounded-md w-full">
                  {{ (getCurrentClaimWorkflow.AnyCanApprove && "Yes") || "No" }}
                </div>
              </div>
            </div>

            <div class="grid grid-cols-1 p-3 gap-5">
              <div class="text-sm">
                <label class="block pb-1">Description</label>
                <textarea
                  v-model="getCurrentClaimWorkflow.Description"
                  required
                  type="text"
                  class="p-2 bg-gray-200 rounded-md w-full"
                  rows="4"
                  maxlength="500"
                  autocorrect="en-US"
                  readonly
                ></textarea>
              </div>
            </div>

            <el-card class="box-card mb-3">
              <div slot="header" class="clearfix">
                <span>Workflow Approvers</span>
              </div>
              <div class="p-2">
                <div class="flex mb-3 mr-0">
                  <div class="col-span-1 flex ml-auto">
                    <div class="flex items-center gap-2">
                      <button
                        @click="showAddApproverToClaimWorkflow = true"
                        class="border-1.5 flex rounded-full py-2 gap-1 px-1.5 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary capitalize"
                      >
                        <img class="h-5" src="@/assets/icons/add.svg" />
                        Add Approver
                      </button>
                    </div>
                  </div>
                </div>

                <el-table
                  :data="decrypt(workflowToView.Approvers, 'ApproverName')"
                  stripe
                  height="250"
                  style="width: 100%"
                >
                  <el-table-column
                    type="index"
                    label="#"
                    width="50"
                  ></el-table-column>
                  <el-table-column
                    prop="ApproverName"
                    label="Approver"
                    width="auto"
                  ></el-table-column>
                  <el-table-column
                    prop="Sequence"
                    label="Sequence"
                    width="150"
                  ></el-table-column>
                  <el-table-column label="Actions" width="150">
                    <template slot-scope="scope">
                      <ve-popper trigger="clickToOpen">
                        <div class="bg-white shadow-md popper">
                          <button
                            class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                            style="border-radius: 0 !important"
                            @click="editApprover(scope.$index)"
                          >
                            Edit
                          </button>

                          <button
                            class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                            style="border-radius: 0 !important"
                            @click="removeApprover(scope.$index)"
                          >
                            Delete
                          </button>
                        </div>

                        <button slot="reference">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            id="Outline"
                            viewBox="0 0 24 24"
                            width="20"
                            height="20"
                          >
                            <circle cx="12" cy="2" r="2" />
                            <circle cx="12" cy="12" r="2" />
                            <circle cx="12" cy="22" r="2" />
                          </svg>
                        </button>
                      </ve-popper>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-card>

            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>Workflow Members</span>
              </div>
              <div class="p-2">
                <div class="flex mb-3 mr-0">
                  <div class="col-span-1 flex ml-auto">
                    <div class="flex items-center gap-2">
                      <button
                        @click="showAddMemberToClaimWorkflow = true"
                        class="border-1.5 flex rounded-full py-2 gap-1 px-1.5 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary capitalize"
                      >
                        <img class="h-5" src="@/assets/icons/add.svg" />
                        Member
                      </button>
                      <button
                        @click="() => handleBulkUploadClick('members')"
                        class="border-1.5 flex rounded-full py-2 px-1.5 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary capitalize"
                      >
                        <img
                          class="h-5"
                          src="@/assets/icons/export-excel.png"
                        />
                        Import
                      </button>
                      <button
                        @click="() => exportTemplate('members')"
                        class="border-1.5 flex rounded-full py-2 px-1.5 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary capitalize"
                      >
                        <img
                          class="h-5"
                          src="@/assets/icons/export-excel.png"
                        />
                        Export
                      </button>
                    </div>
                  </div>
                </div>

                <el-table
                  :data="decrypt(workflowToView.Members, 'MemberName')"
                  stripe
                  height="250"
                  style="width: 100%"
                >
                  <el-table-column
                    type="index"
                    label="#"
                    width="50"
                  ></el-table-column>
                  <el-table-column
                    prop="EmployeeNo"
                    label="EmployeeNo"
                    width="150"
                  ></el-table-column>
                  <el-table-column
                    prop="MemberName"
                    label="Name"
                    width="auto"
                  ></el-table-column>

                  <el-table-column label="Actions" width="150">
                    <template slot-scope="scope">
                      <ve-popper trigger="clickToOpen">
                        <div class="bg-white shadow-md popper">
                          <button
                            class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                            style="boder-radius: 0 !important"
                            @click="removeMember(scope.$index)"
                          >
                            Delete
                          </button>
                        </div>

                        <button slot="reference">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            id="Outline"
                            viewBox="0 0 24 24"
                            width="20"
                            height="20"
                          >
                            <circle cx="12" cy="2" r="2" />
                            <circle cx="12" cy="12" r="2" />
                            <circle cx="12" cy="22" r="2" />
                          </svg>
                        </button>
                      </ve-popper>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-card>
          </div>
        </div>
      </div>
    </transition>
    <BulkUpload
      v-if="showBulkUpload"
      :close="closeBulkUpload"
      :showBulkUpload="showBulkUpload"
      :showBulkUploadCallback="showBulkUploadCallback"
      title="Claim Workflow Users Bulk Upload"
      :dataType="dataType"
      :url="url"
      :dateColumns="[]"
      :columns="claimWorkflowUsersBulkUploadColumns"
    ></BulkUpload>
    <AddMemberToClaimWorkflow
      :showAddMemberToClaimWorkflow="showAddMemberToClaimWorkflow"
      @close="showAddMemberToClaimWorkflow = false"
      :workFlowName="workflowToView"
      :getWorkflow="getWorkflow"
      :getNewMember="getNewMember"
    ></AddMemberToClaimWorkflow>
    <AddApproverToClaimWorkflow
      :showAddApproverToClaimWorkflow="showAddApproverToClaimWorkflow"
      @close="showAddApproverToClaimWorkflow = false"
      :workflowToView="workflowToView"
      :getWorkflow="getWorkflow"
      :getNewApprover="getNewApprover"
    ></AddApproverToClaimWorkflow>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";
import axios from "axios";
import { importTemplateGenerator } from "@/utils/importTemplateGenerator";
import claimWorkflowUsersBulkUploadColumns from "../../../data/claimWorkflowUsersBulkUploadColumns";
import decryptData from "@/utils/decrypt";
export default {
  name: "ClaimWorkflowViewUserGroups",
  props: ["showClaimWorkflow", "workflowToView", "getWorkflow", "reload"],
  components: {
    Loader,
    BulkUpload: () => import("@/utils/bulkUploadsUtils.vue"),
    AddMemberToClaimWorkflow: () =>
      import(
        "@/components/CompanySetups/claimWorkflow/addMemberToWorkflow.vue"
      ),

    AddApproverToClaimWorkflow: () =>
      import(
        "@/components/CompanySetups/claimWorkflow/addApproverToWorkflow.vue"
      ),
  },
  data() {
    return {
      decryptDataLocal: "",
      decryptionKey: "",
      workflows: null,
      dataType: null,
      url: null,
      claimWorkflowUsersBulkUploadColumns: null,
      showBulkUpload: false,
      EmployeeNo: null,
      locations: [], // add locations data
      reason: "",
      loading: false,
      departments: [],
      isEditing: false,
      create_success: null,
      create_error: null,
      get_error: null,
      employees: [],
      selectedFullname: null,
      selectedEmployees: null,
      showAddMemberToClaimWorkflow: false,
      showAddApproverToClaimWorkflow: false,
      selectedUser: null,
      sequenceNumber: "",
      claimWorkflowData: {
        Name: "",
        Description: "",
        ClaimWorkflowLineRequest: [
          {
            EmployeeId: "",
            Sequence: 0,
          },
        ],
      },
      columns: [
        {
          field: "",
          key: "a",
          title: "#",
          width: 50,
          align: "left",

          operationColumn: true,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            row, column, h;
            return ++rowIndex;
          },
        },
        {
          field: "EmployeeNo",
          key: "employeeNo",
          title: "Employee No",
          align: "center",
          headerAlign: "center",
          sampleValue: "EMPLOYEE-01",
        },
        {
          field: "WorkflowName",
          key: "WorkflowName",
          title: "Workflow Name",
          align: "left",
          sampleValue: "Test Workflow",
        },
      ],
      // table data
    };
  },

  computed: {
    ...mapGetters([
      "getOrganization",
      "getToken",
      "getEmployees",
      "getCurrentClaimWorkflow",
    ]),
  },

  created() {
    //console.log(this.getCurrentClaimWorkflow)
    this.decryptDataLocal = decryptData;
    this.decryptionKey = this.$decryptionKey;
    this.claimWorkflowUsersBulkUploadColumns =
      claimWorkflowUsersBulkUploadColumns;
  },

  methods: {
    decrypt(data, attributeName) {
      console.log(data);
      return data.map((member) => {
        return {
          ...member,
          [attributeName]: decryptData(
            member[attributeName],
            this.$decryptionKey
          ),
        };
      });
    },

    getNewMember(data) {
      const { Members } =
        this.workflowToView &&
        data.find((workflow) => workflow.Id == this.workflowToView.Id);
      console.log(Members);
      this.getCurrentClaimWorkflow.Members = Members;
      console.log(this.getCurrentClaimWorkflow.Members);
    },

    getNewApprover(data) {
      console.log(data);
      const { Approvers } = data.find(
        (workflow) => workflow.Id == this.workflowToView.Id
      );
      console.log(Approvers);
      this.getCurrentClaimWorkflow.Members = Approvers;
      console.log(this.getCurrentClaimWorkflow.Approvers);
    },

    removeApprover() {},

    exportTemplate(type) {
      if (type === "approvers") {
        importTemplateGenerator(
          this.columns.filter((c) => c.title !== "#"),
          "UploadClaimWorkflowMembers",
          [
            {
              EmployeeNo: "01",
              Sequence: 0,
            },
          ]
        );
      } else {
        importTemplateGenerator(
          this.columns.filter((c) => c.title !== "#"),
          "ClaimMembers",
          [
            {
              EmployeeNo: "01",
              WorkflowName: "Test Workflow",
            },
          ]
        );
      }
    },
    showBulkUploadCallback() {
      this.reload();

      this.showBulkUpload = false;
    },
    closeBulkUpload() {
      this.showBulkUpload = false;
    },

    handleBulkUploadClick(type) {
      if (type === "approvers") {
        this.url = `/setup/claim/workflow/bulk/${this.$ApiVersion}/upload`;
        this.dataType = "ClaimApprovers";
      } else {
        // /{organization}/setup/claim/member/v1/upload
        this.url = `/setup/claim/member/${this.$ApiVersion}/upload`;
        this.dataType = "ClaimMembers";
      }
      this.showBulkUpload = true;
    },

    async removeMember(index) {
      // this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": " application/json",
        },
      };

      let claimWorkflowMemberId = this.getEmployees.find(
        (employee) =>
          employee.EmployeeNo === this.workflowToView.Members[index].EmployeeNo
      ).Id;
      // Remove the user from the workflow based on the index
      // const claimWorkflowMemberId = this.workflowToView.lines[index].Id;

      // /{organization}/setup/claim/workflow/members/{claimWorkflowMemberId}/v1/delete
      // /{organization}/setup/claim/workflow/members/v1/add
      try {
        const response = await axios.delete(
          `${this.getOrganization}/setup/claim/workflow/members/${claimWorkflowMemberId}/${this.$ApiVersion}/delete`,

          options
        );
        if (response.data.StatusCode == 200) {
          this.workflowToView.Members.splice(index, 1);
          this.$notify({
            title: "Success",
            message: response.data.StatusMessage,
            type: "success",
          });
          this.getWorkflow();
          setTimeout(() => {
            this.create_success = null;
          }, 2000);
        } else {
          this.$notify.error({
            title: "Failure",
            message: response.data.StatusMessage,
          });
          setTimeout(() => {
            this.create_error = null;
          }, 2000);
        }
      } catch (error) {
        this.$notify.error({ title: "Failure", message: error.message });
        setTimeout(() => {
          this.create_error = null;
        }, 2000);
      }
      this.workflowToView.lines.splice(index, 1);
    },

    close() {
      this.$emit("close");
      this.tableData = [
        {
          EmployeeName: "",
          Sequence: "",
          Id: "",
        },
      ];
    },

    getEmployeeById(EmployeeId) {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/employee/${EmployeeId}/general/${this.$ApiVersion}/info`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              //console.log(response.data);
              // //console.log(this.employees)
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
